const ResourceTypeId = {
  CRYSTAL: "etoa:crystal",
  ENERGY: "etoa:energy",
  FOOD: "etoa:food",
  FUEL: "etoa:fuel",
  METAL: "etoa:metal",
  PEOPLE: "etoa:people",
  PLASTIC: "etoa:plastic",
  ARMOR: "etoa:armor",
  EXPERIENCE: "etoa:experience",
  REGENERATION: "etoa:regeneration",
  SHIELDS: "etoa:shields",
  WEAPONS: "etoa:weapons",
  ANTRAX: "etoa:antrax",
  BOMBARDMENT: "etoa:bombardment",
  CAPACITY: "etoa:capacity",
  EMP: "etoa:emp",
  ESPIONAGE: "etoa:espionage",
  FLIGHT_SPEED: "etoa:flight_speed",
  PILOTS: "etoa:pilots",
  POISON: "etoa:poison",
  STEALTH: "etoa:stealth",
  READINESS: "etoa:readiness"
};

export { ResourceTypeId };
